// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@tailwind base;
@tailwind components;
@tailwind utilities;


@layer components {

    .title {
        @apply text-white opacity-85 uppercase;
    }

    .nav-link {
        @apply block text-sm/[14px] text-[grey] uppercase py-[26px] px-[30px] font-medium;
    }

    .nav-link-active {
        @apply bg-primary rounded-b-lg text-black hover:bg-primary-100;
    }

    .nav-link-hover {
        @apply hover:bg-[rgba(234,205,64,0.20)] rounded-b-lg;
    }

    .btn {
        @apply rounded-lg border-[1px] font-medium text-sm/[14px] border-primary gap-[10px]
        hover:border-primary-100
        disabled:bg-grey-150 disabled:hover:bg-grey-150 disabled:border-none disabled:text-grey-900;
    }

    .btn-default {
        @apply text-primary;
    }

    .btn-link {
        @apply text-blue underline text-sm/[24px];
    }

    .btn-primary {
        @apply bg-primary text-black hover:bg-primary-100 px-[25px] py-[12px] ;
    }

    .btn-4 {
        @apply inline-flex items-center justify-center
        border border-[#C8C9CB]
        rounded-[4px]
        px-[25px] py-[12px]
        text-[#C8C9CB] text-center text-[14px] hover:text-white
        font-roboto font-normal disabled:bg-grey-150 disabled:hover:bg-grey-150 disabled:border-none disabled:text-grey-900;
    }

    .btn-pgn {
        @apply inline-flex items-center justify-center border border-[#C8C9CB] rounded-[4px] w-[32px] h-[32px]
    }

    .btn-pgn-active {
        @apply bg-[#009BDE] border-none;
    }

    .checkbox {
        @apply bg-[#009BDE]
    }

    .label {
        @apply text-[12px] font-normal text-white opacity-45;
    }

    .label-error {
        @apply text-red opacity-100;
    }

    .label-new {
        @apply text-blue opacity-100;
    }

    .input {
        @apply h-10 bg-black bg-opacity-25 placeholder-white placeholder-opacity-25 text-sm rounded-[4px] block pt-2.5 pb-1.5 px-5 focus:outline-none;
    }

    .input-error {
        @apply border border-red;
    }

    .input-new {
        @apply border border-blue;
    }

    .link {
        @apply text-[#009BDE] underline cursor-pointer;
    }

    .bg-sport-banner {
        /* background-image: url('./components/wager/sport_banner.png'); Используйте относительный путь или импортированное изображение */
        background-size: cover;
        background-position: center;
    }

    .quick-access-card {
        @apply flex desktop:!w-[392px] notebook:!w-[330px] tablet:w-[333px] w-[300px] h-[234px] p-[24px] pr-[12px] pb-[12px] pl-[24px] rounded-[8px] bg-[#1D2126];
    }

    .personal-info-card {
        @apply flex flex-col gap-[10px] w-full rounded-[8px] bg-[#171A1E] px-[20px] pt-[15px] pb-[20px]
    }

    .personal-info-field {
        @apply text-white;
    }

    .table-row {
        @apply p-[10px] border border-[#272D33]
    }

    .overlay-modal {
        @apply justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none
    }

    .card-basic {
        @apply flex flex-col gap-[10px] w-full px-[20px] pb-[20px] pt-[15px] rounded-[8px] bg-[#1D2126];
    }

    .card-1-wrapper {
        @apply flex flex-col w-full
    }

    .card-1-head {
        @apply flex gap-[20px] rounded-t-[8px] bg-[#171A1E] pb-[12px] pl-[20px] pr-[10px] pt-[10px] items-center
    }

    .card-1-body {
        @apply flex flex-col gap-[20px] bg-[#1D2126] rounded-b-[8px] px-[20px] pt-[15px] pb-[20px]
    }

    .custom-scrollbar {
        @apply overflow-y-auto;
    }

    .custom-scrollbar::-webkit-scrollbar {
        width: 6px;
    }

    .custom-scrollbar::-webkit-scrollbar-track {
        @apply bg-transparent;
    }

    .custom-scrollbar::-webkit-scrollbar-thumb {
        @apply bg-gray-500 rounded-md;
    }

    .custom-scrollbar::-webkit-scrollbar-thumb:hover {
        @apply bg-gray-400;
    } 


}

::-webkit-scrollbar {
    width: 0;
    /*scrollbar-width: none;*/
}

html {
    scrollbar-width: none;
    -ms-overflow-style: none;
}

a {
    font-size: 14px;
}

table {
    width: 100%;
    border: none;
}
table thead th {
    text-align: left;
    border: none;
    padding: 10px 15px;
    font-size: 14px;
    font-weight: normal;
}
table tbody td {
    text-align: left;
    padding: 10px 15px;
    font-size: 14px;
    vertical-align: top;
}
table thead tr th:first-child, table tbody tr td:first-child {
    border-left: none;
}
table thead tr th:last-child, table tbody tr td:last-child {
    border-right: none;
}

.pre-wrap {
    white-space: pre-wrap;
}

@keyframes preloadAnimation {
    from {background-position: 100% 0}
    to {background-position: -80% 0}
}

.placeholder {
    background: linear-gradient(to right, #171A1E 8%, #1e2326 18%, #171A1E 33%);
    background-size: 200% 50px;
    animation: preloadAnimation 1.5s infinite;
    border-collapse:collapse;
    width:100%;
    height: 50px;
    margin-top: 1px;
    border-radius: 8px;
}
`, "",{"version":3,"sources":["webpack://./index.css"],"names":[],"mappings":"AAAA,cAAc;AACd,oBAAoB;AACpB,mBAAmB;;;AAGnB;;IAEI;QACI,sCAAsC;IAC1C;;IAEA;QACI,iFAAiF;IACrF;;IAEA;QACI,8DAA8D;IAClE;;IAEA;QACI,oDAAoD;IACxD;;IAEA;QACI;;mGAE2F;IAC/F;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,yCAAyC;IAC7C;;IAEA;QACI,sEAAsE;IAC1E;;IAEA;QACI;;;;;2HAKmH;IACvH;;IAEA;QACI;IACJ;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI;IACJ;;IAEA;QACI,oDAAoD;IACxD;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,6IAA6I;IACjJ;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,8CAA8C;IAClD;;IAEA;QACI,iIAAiI;QACjI,sBAAsB;QACtB,2BAA2B;IAC/B;;IAEA;QACI,yJAAyJ;IAC7J;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,+FAA+F;IACnG;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,kBAAkB;IACtB;;;AAGJ;;AAEA;IACI,QAAQ;IACR,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,MAAM,2BAA2B;IACjC,IAAI,2BAA2B;AACnC;;AAEA;IACI,2EAA2E;IAC3E,0BAA0B;IAC1B,yCAAyC;IACzC,wBAAwB;IACxB,UAAU;IACV,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB","sourcesContent":["@tailwind base;\r\n@tailwind components;\r\n@tailwind utilities;\r\n\r\n\r\n@layer components {\r\n\r\n    .title {\r\n        @apply text-white opacity-85 uppercase;\r\n    }\r\n\r\n    .nav-link {\r\n        @apply block text-sm/[14px] text-[grey] uppercase py-[26px] px-[30px] font-medium;\r\n    }\r\n\r\n    .nav-link-active {\r\n        @apply bg-primary rounded-b-lg text-black hover:bg-primary-100;\r\n    }\r\n\r\n    .nav-link-hover {\r\n        @apply hover:bg-[rgba(234,205,64,0.20)] rounded-b-lg;\r\n    }\r\n\r\n    .btn {\r\n        @apply rounded-lg border-[1px] font-medium text-sm/[14px] border-primary gap-[10px]\r\n        hover:border-primary-100\r\n        disabled:bg-grey-150 disabled:hover:bg-grey-150 disabled:border-none disabled:text-grey-900;\r\n    }\r\n\r\n    .btn-default {\r\n        @apply text-primary;\r\n    }\r\n\r\n    .btn-link {\r\n        @apply text-blue underline text-sm/[24px];\r\n    }\r\n\r\n    .btn-primary {\r\n        @apply bg-primary text-black hover:bg-primary-100 px-[25px] py-[12px] ;\r\n    }\r\n\r\n    .btn-4 {\r\n        @apply inline-flex items-center justify-center\r\n        border border-[#C8C9CB]\r\n        rounded-[4px]\r\n        px-[25px] py-[12px]\r\n        text-[#C8C9CB] text-center text-[14px] hover:text-white\r\n        font-roboto font-normal disabled:bg-grey-150 disabled:hover:bg-grey-150 disabled:border-none disabled:text-grey-900;\r\n    }\r\n\r\n    .btn-pgn {\r\n        @apply inline-flex items-center justify-center border border-[#C8C9CB] rounded-[4px] w-[32px] h-[32px]\r\n    }\r\n\r\n    .btn-pgn-active {\r\n        @apply bg-[#009BDE] border-none;\r\n    }\r\n\r\n    .checkbox {\r\n        @apply bg-[#009BDE]\r\n    }\r\n\r\n    .label {\r\n        @apply text-[12px] font-normal text-white opacity-45;\r\n    }\r\n\r\n    .label-error {\r\n        @apply text-red opacity-100;\r\n    }\r\n\r\n    .label-new {\r\n        @apply text-blue opacity-100;\r\n    }\r\n\r\n    .input {\r\n        @apply h-10 bg-black bg-opacity-25 placeholder-white placeholder-opacity-25 text-sm rounded-[4px] block pt-2.5 pb-1.5 px-5 focus:outline-none;\r\n    }\r\n\r\n    .input-error {\r\n        @apply border border-red;\r\n    }\r\n\r\n    .input-new {\r\n        @apply border border-blue;\r\n    }\r\n\r\n    .link {\r\n        @apply text-[#009BDE] underline cursor-pointer;\r\n    }\r\n\r\n    .bg-sport-banner {\r\n        /* background-image: url('./components/wager/sport_banner.png'); Используйте относительный путь или импортированное изображение */\r\n        background-size: cover;\r\n        background-position: center;\r\n    }\r\n\r\n    .quick-access-card {\r\n        @apply flex desktop:!w-[392px] notebook:!w-[330px] tablet:w-[333px] w-[300px] h-[234px] p-[24px] pr-[12px] pb-[12px] pl-[24px] rounded-[8px] bg-[#1D2126];\r\n    }\r\n\r\n    .personal-info-card {\r\n        @apply flex flex-col gap-[10px] w-full rounded-[8px] bg-[#171A1E] px-[20px] pt-[15px] pb-[20px]\r\n    }\r\n\r\n    .personal-info-field {\r\n        @apply text-white;\r\n    }\r\n\r\n    .table-row {\r\n        @apply p-[10px] border border-[#272D33]\r\n    }\r\n\r\n    .overlay-modal {\r\n        @apply justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none\r\n    }\r\n\r\n    .card-basic {\r\n        @apply flex flex-col gap-[10px] w-full px-[20px] pb-[20px] pt-[15px] rounded-[8px] bg-[#1D2126];\r\n    }\r\n\r\n    .card-1-wrapper {\r\n        @apply flex flex-col w-full\r\n    }\r\n\r\n    .card-1-head {\r\n        @apply flex gap-[20px] rounded-t-[8px] bg-[#171A1E] pb-[12px] pl-[20px] pr-[10px] pt-[10px] items-center\r\n    }\r\n\r\n    .card-1-body {\r\n        @apply flex flex-col gap-[20px] bg-[#1D2126] rounded-b-[8px] px-[20px] pt-[15px] pb-[20px]\r\n    }\r\n\r\n    .custom-scrollbar {\r\n        @apply overflow-y-auto;\r\n    }\r\n\r\n    .custom-scrollbar::-webkit-scrollbar {\r\n        width: 6px;\r\n    }\r\n\r\n    .custom-scrollbar::-webkit-scrollbar-track {\r\n        @apply bg-transparent;\r\n    }\r\n\r\n    .custom-scrollbar::-webkit-scrollbar-thumb {\r\n        @apply bg-gray-500 rounded-md;\r\n    }\r\n\r\n    .custom-scrollbar::-webkit-scrollbar-thumb:hover {\r\n        @apply bg-gray-400;\r\n    } \r\n\r\n\r\n}\r\n\r\n::-webkit-scrollbar {\r\n    width: 0;\r\n    /*scrollbar-width: none;*/\r\n}\r\n\r\nhtml {\r\n    scrollbar-width: none;\r\n    -ms-overflow-style: none;\r\n}\r\n\r\na {\r\n    font-size: 14px;\r\n}\r\n\r\ntable {\r\n    width: 100%;\r\n    border: none;\r\n}\r\ntable thead th {\r\n    text-align: left;\r\n    border: none;\r\n    padding: 10px 15px;\r\n    font-size: 14px;\r\n    font-weight: normal;\r\n}\r\ntable tbody td {\r\n    text-align: left;\r\n    padding: 10px 15px;\r\n    font-size: 14px;\r\n    vertical-align: top;\r\n}\r\ntable thead tr th:first-child, table tbody tr td:first-child {\r\n    border-left: none;\r\n}\r\ntable thead tr th:last-child, table tbody tr td:last-child {\r\n    border-right: none;\r\n}\r\n\r\n.pre-wrap {\r\n    white-space: pre-wrap;\r\n}\r\n\r\n@keyframes preloadAnimation {\r\n    from {background-position: 100% 0}\r\n    to {background-position: -80% 0}\r\n}\r\n\r\n.placeholder {\r\n    background: linear-gradient(to right, #171A1E 8%, #1e2326 18%, #171A1E 33%);\r\n    background-size: 200% 50px;\r\n    animation: preloadAnimation 1.5s infinite;\r\n    border-collapse:collapse;\r\n    width:100%;\r\n    height: 50px;\r\n    margin-top: 1px;\r\n    border-radius: 8px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
